module.exports = __webpack_public_path__ + "media/packs/images/panes/location-169b3cf60e57d6bff8a1220676ee399e.svg";